class PublishingGroup {
  constructor(id, publishingGroupId, accountId, remoteIds, label, providerName, imageUrl) {
    this.id = id;
    this.publishingGroupId = publishingGroupId;
    this.accountId = accountId;
    this.remoteIds = remoteIds;
    this.label = label;
    this.name = label; // Legacy code uses the field name
    this.provider = !!providerName ? providerName.toUpperCase() : null; // Use the Provider DB name (i.e. uppercase).
    this.imageUrl = imageUrl;
    this.pageType = "Group";
  }
}

export default PublishingGroup;
